export interface NewsIndispo {
  identifiant: number;
  auteur: string;
  titre: string;
  contenu: string;
  destination: NewsIndispoDestination;
  categorieEnum: NewsIndispoCategorie;
  publicationAccueil: number;
  dateDebut: string;
  dateFin: string;
  dateCreation: string;
  notification: number;
}

export enum NewsIndispoCategorie {
  news = 'NEWS',
  indispo = 'INDISPONIBILITE',
}

export enum NewsIndispoDestination {
  ecrt = 'ECRT',
  mobile = 'MOBILITE',
}
